import { render, staticRenderFns } from "./Deployments.vue?vue&type=template&id=62e8dcc1&"
import script from "./Deployments.vue?vue&type=script&lang=js&"
export * from "./Deployments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports